<template>
  <v-app>
    <OPrompt ref="prompt" />
    <OConfirmDialog ref="theConfirm" />
    <OInfoDialog ref="infoDialog" />
    <OErrorDialog ref="errorDialog" />
    <OSnackbar ref="snackbar" />
    <VisDialog ref="visDialog" />
    <OLoadingDialog :value="rootLoading" ref="rootLoadingDialog" />

    <OFullPageLoading v-if="theUser.state == 'starting'" />

    <LoginForm
      v-if="theUser.state == 'waiting-login'"
      color="blue"
      :theUser="theUser"
      :logo="require('./assets/Admin3-Logo.svg')"
    />

    <template v-if="theUser.state == 'logged-in'">
      <MobileApp v-if="$isMobile" />

      <template v-else>
        <!-- <MainNavigationV/> -->
        <MainNavigationH />
        <!-- <v-app-bar app dark fixed :clippedLeft="true" style="z-index: 5">
          <v-toolbar-title class="headline text-uppercase mr-4">
            <div>
              <router-link to="/health/queues">
                <v-img
                  :src="require('./assets/logo-oderon-bw-40.png')"
                  height="40"
                  width="40"
                />
              </router-link>
            </div>
          </v-toolbar-title>

          <AdminMainMenu />

          <BoltButton />

          <v-spacer></v-spacer>

          <v-toolbar-items>
            <v-btn text @click="doLogout">Logout</v-btn>
          </v-toolbar-items>
        </v-app-bar> -->

        <router-view></router-view>
      </template>
    </template>
  </v-app>
</template>

<script>
import Vue from 'vue'
import TheUser from 'oderon-vue/auth/TheUser'
import { delay } from 'oderon-commons/src/utils'
import MobileApp from './views/mobile/App.vue'
import MainNavigationH from './components/MainNavigationH.vue'
import VisDialog from './views/vis/VisDialog.vue'

export default {
  name: 'App',
  data() {
    return {
      rootLoading: false,
      isLoading: false,
      theUser: TheUser,
      showingMobileMenu: false
    }
  },
  components: {
    LoginForm: require('oderon-vue/auth/LoginForm').default,
    OErrorDialog: require('oderon-vue/cpts/OErrorDialog').default,
    OFullPageLoading: require('oderon-vue/cpts/OFullPageLoading').default,
    OPrompt: require('oderon-vue/cpts/OPrompt').default,
    OSnackbar: require('oderon-vue/cpts/OSnackbar').default,
    OConfirmDialog: require('oderon-vue/cpts/OConfirmDialog').default,
    OInfoDialog: require('oderon-vue/cpts/OInfoDialog').default,
    MobileApp,
    MainNavigationH,
    VisDialog
  },
  mounted() {
    Vue.prototype.$showErr = this.$refs.errorDialog.show
    Vue.prototype.$snack = this.$refs.snackbar.show
    Vue.prototype.$prompt = this.$refs.prompt.open

    Vue.prototype.$vis = this.$refs.visDialog.open

    Vue.prototype.$rootLoading = async (prom) => {
      try {
        this.rootLoading = true
        if (typeof prom === 'function') prom = prom()
        return await prom
      } catch (err) {
        this.$showErr(err)
      } finally {
        this.rootLoading = false
      }
    }

    // Idem $confirm mas assume algumas cores e textos.
    Vue.prototype.$confirm = this.$refs.theConfirm.open
    Vue.prototype.$confirmDelete = this.$refs.theConfirm.confirmDelete
    Vue.prototype.$confirmDeactivate = this.$refs.theConfirm.confirmDeactivate

    Vue.prototype.$info = this.$refs.infoDialog.open
    Vue.prototype.$delay = delay
    this.theUser.tryExistingToken()
  },
  methods: {
    doLogout() {
      this.theUser.logout()
    }
  }
}
</script>
